(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  function addHiddenProperty(form, name, value) {
    let input = form.querySelector(`input[data-legacy-property="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.dataset.legacyProperty = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function setButtonText(button, text) {
    const target = button.querySelector('.add-to-cart-text__content span span') ||
      button.querySelector('.add-to-cart-text__content span') ||
      button.querySelector('.add-to-cart-text__content');
    if (target) target.textContent = text;
  }

  function initialiseLaunchControl(panel) {
    const rawDate = panel.dataset.launchAt;
    const launchAt = new Date(rawDate);
    if (!rawDate || Number.isNaN(launchAt.getTime())) {
      panel.classList.add('legacy-launch-control--invalid');
      return;
    }

    const preorder = panel.dataset.enablePreorder === 'true';
    const productSection = panel.closest('.shopify-section') || document;
    const productForms = Array.from(productSection.querySelectorAll('form[action*="/cart/add"]'));
    const buttons = Array.from(productSection.querySelectorAll('button[name="add"], [data-testid="standalone-add-to-cart"]'));
    const accelerated = Array.from(productSection.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button'));

    const applyPreLaunchState = () => {
      if (preorder) {
        buttons.forEach((button) => {
          setButtonText(button, panel.dataset.preorderLabel || 'Pre-order now');
          button.classList.add('legacy-preorder-button');
        });
        productForms.forEach((form) => {
          addHiddenProperty(form, 'Order type', 'Pre-order');
          addHiddenProperty(form, 'Release date', rawDate);
        });
        accelerated.forEach((node) => node.classList.add('legacy-launch-hidden'));
        document.body.classList.add('legacy-preorder-active');
      } else {
        buttons.forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          setButtonText(button, panel.dataset.comingSoonLabel || 'Coming soon');
          button.classList.add('legacy-coming-soon-button');
        });
        accelerated.forEach((node) => node.classList.add('legacy-launch-hidden'));
        document.body.classList.add('legacy-launch-locked');
      }
    };

    const update = () => {
      const distance = launchAt.getTime() - Date.now();
      if (distance <= 0) {
        panel.classList.add('legacy-launch-control--complete');
        setTimeout(() => window.location.reload(), 900);
        return false;
      }
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      const values = { days, hours, minutes, seconds };
      Object.entries(values).forEach(([key, value]) => {
        const el = panel.querySelector(`[data-${key}]`);
        if (el) el.textContent = pad(value);
      });
      return true;
    };

    if (launchAt.getTime() > Date.now()) {
      applyPreLaunchState();
      update();
      const timer = window.setInterval(() => {
        if (!update()) window.clearInterval(timer);
      }, 1000);
    } else {
      panel.remove();
    }
  }

  const boot = () => document.querySelectorAll('[data-legacy-launch-control]').forEach(initialiseLaunchControl);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
